import { useState } from "react";
import { Button, Form, Input, message } from "antd";

export const ContactForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const validateMessages = {
    // eslint-disable-next-line no-template-curly-in-string
    required: "${label} is required!",
    types: {
      // eslint-disable-next-line no-template-curly-in-string
      email: "${label} is not a valid email!",
    },
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await fetch("https://mercuri-app-api.onrender.com/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        message.success("Message sent successfully!");
        form.resetFields();
      } else {
        message.error("Failed to send message. Please try again later.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      message.error("An error occurred. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
      validateMessages={validateMessages}
    >
      <Form.Item label="Name" name="name" rules={[{ required: true }]}>
        <Input placeholder="Enter your name" />
      </Form.Item>
      <Form.Item
        label="Email"
        name="email"
        rules={[
          {
            required: true,
            type: "email",
          },
        ]}
      >
        <Input placeholder="Enter your email" />
      </Form.Item>
      <Form.Item label="Message" name="message" rules={[{ required: true }]}>
        <Input.TextArea placeholder="Enter your message" rows={4} />
      </Form.Item>
      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button
          className="btn-primary"
          htmlType="submit"
          loading={loading}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}
        >
          <span>
            {loading ? "Sending..." : "Send"}
            {!loading && <i className="fa fa-paper-plane" />}
          </span>
        </Button>
      </Form.Item>
    </Form>
  );
};
